import React, { Component } from 'react';
import _ from 'lodash';
import { Popover } from 'antd';
import PubSub from 'pubsub-js';
import * as commonActionType from '@common/store/common/common.actionsType';

class DDadosBase extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.isView) {
      return this.renderView();
    } else if (this.props.isHeader) {
      return this.renderHeader();
    } else return this.renderComponent();
  }

  renderHeader() {}

  renderComponent() {}

  renderView() {}
}

export default DDadosBase;

class LabeledInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { props } = this;
    return (
      <span>
        {!!props?.LabelSpace ? (
          <label>&nbsp;</label>
        ) : (
          <label style={{ lineHeight: '1' }}>
            {props.Label}
            {props.Obrigatorio && <span className="required-star" />}
            {props.Ajuda && (
              <Popover
                content={props.Ajuda}
                overlayStyle={{ maxWidth: props.AjudaWidth ?? '380px', fontSize: 14 }}
                placement={props.PlacementAjuda || 'top'}
              >
                <i style={{ cursor: 'help' }} className="fas fa-question-circle ml-1"></i>
              </Popover>
            )}
          </label>
        )}
        {props.children}
      </span>
    );
  }
}

export { LabeledInput };
